// Copyright 2022, Durable
import { useTheme } from "@mui/material";
import React from "react";

const logoFiles = {
  black: {
    logo: "/static/DurableBlackIcon.svg",
    text: null,
    stack: null
  },
  white: {
    logo: "/static/DurableWhiteIcon.svg",
    text: "/static/DurableWhiteHorizontal.svg",
    stack: "/static/DurableWhiteStacked.svg"
  },
  color: {
    logo: "/static/DurableColorIcon.svg",
    text: "/static/DurableColorHorizontal.svg",
    stack: "/static/DurableColorStacked.svg"
  },
  inverse: {
    logo: "/static/DurableColorIcon.svg",
    text: "/static/DurableInverseHorizontal.svg",
    stack: "/static/DurableInverseStacked.svg"
  }
};

/**
 * A single component that returns a SVG of any available style of durable logo.
 *
 * @return {React.ReactElement} component containing durable logo.
 */
function DurableLogo({
  variant = "color",
  type = "text",
  size = 200
}: {
  variant?: string;
  type?: string;
  size?: number;
}) {
  const theme = useTheme();
  const dynamicColor = theme.palette.mode === "dark" ? "inverse" : "color";
  if (variant == "dynamic") {
    variant = dynamicColor;
  }
  const logo =
    logoFiles[variant][type] != null ? (
      <img
        src={logoFiles[variant][type]}
        width={size}
        style={{
          transition: "width 200ms"
        }}
        alt="Durable"
      />
    ) : (
      <></>
    );
  return logo;
}

export { DurableLogo };
